import notification from './Feedback/Notification';

const createNotification = (type, message, description, silent) => {
  if (!message && silent) return false;
  if (type === 'error' && !message) message = 'Server error. Please try again.';
  if (silent === true) return false;
  notification[type]({
    message,
    description,
  });
};
export default createNotification;
